import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { COOKIE } from '@app-lib';

@Injectable()
export class AuthGuard  {
  constructor(private router: Router, private _cookie: CookieService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const accessToken = this._cookie.get(COOKIE.SYS_JWT);
    if (accessToken != null) {
      return true;
    } else {
      console.warn('NG.AUT.GUA.WAR.00 -> AuthGuard: accessToken NULL redirect to /login');
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}
